module.exports = __webpack_public_path__ + "img/package.ede156dc.svg";